import React, {Component} from 'react';
import {observer} from 'mobx-react';

import CustomerApiService from '@lib/api-services/CustomerApiService';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import buildResourcePath from '@lib/buildResourcePath'

import CustomerGeneralInformation from './CustomerGeneralInformation';
import CustomerAccess from './CustomerAccess';
import CustomerHistory from './CustomerHistory';
import CustomerStore from '../../store/customerStore'
import ExpandableFloatingDropdown from '../common/ExpandableFloatingDropdown';
import Button from '../common/Button';
import IconSave from '../icons/IconSave';

const customerEditPage = observer(
    class CustomerEditPage extends Component {
        constructor(props) {
            super(props);
            CustomerStore.initModel({
                id: props.model.id,
                canDelete: props.model.canDelete,
                generalInformation: props.model.generalInformation,
                access: props.model.access,
                historyItems: (props.model.editInformation || {}).audits || []
            })

            scheduleAtDocumentReady(() => {
                this.customerApiService = APIServicesRegistry.getService(CustomerApiService)
            })

            window.onbeforeunload = e => {
                e = e || window.event;

                if (CustomerStore.dirty) {
                    const message = __('Changes that you have made will not be saved.');

                    if (e) {
                        e.returnValue = message;
                    }

                    return message;
                }
            }
        }

        onSaveClick = () => {
            if (!CustomerStore.canSave())
                return;

            CustomerStore.setDuringSave(true);

            var model = CustomerStore.getTransformedFormModel();
            CustomerStore.setDirty(false);
            if (CustomerStore.isNew())
                this.customerApiService.create(model).then(() => {
                    CustomerStore.setDuringSave(false);
                });
            else
                this.customerApiService.edit(model).then(() => {
                    CustomerStore.setDuringSave(false);
                });
        }

        onDeleteClick = () => {
            this.customerApiService.delete(this.props.model.id.value).then(res => {
                window.location.href = buildResourcePath('Customers')
            })
        }

        onCopyClick = () => this.customerApiService.copy(this.props.model.id.value)

        render() {
            const actions = [];
            if (!CustomerStore.isNew()) {
                actions.push({label: __('Copy'), disabled: false, onClick: this.onCopyClick});
            }

            if (CustomerStore.canDelete()) {
                actions.push({label: __('Delete'), disabled: false, onClick: this.onDeleteClick});
            }

            actions.push({
                label: __('Save'),
                className: "button-save",
                icon: IconSave,
                theme: Button.Theme.BorderOnly,
                disabled: !CustomerStore.canSave(),
                onClick: this.onSaveClick
            });

            return (
                <div className="customer-edit-page page-body-container page-container">
                    <div className="page-body-titlebar">
                        <h3 className="page-body-title">{this.props.model.title}</h3>
                        <div className="page-body-action-buttons">
                            <div className="desktop-only">
                                {actions.map((action, idx) => (
                                    <Button key={idx} disabled={action.disabled} icon={action.icon} theme={action.theme}
                                            className={action.className}
                                            onClick={action.onClick}>{action.label}</Button>
                                ))}
                            </div>
                        </div>

                        <div className="customer-edit-page-floaters mobile-only">
                            <ExpandableFloatingDropdown>
                                {actions.map((action, idx) => (
                                    <ExpandableFloatingDropdown.Item key={idx}
                                                                     onClick={action.onClick}>{action.label}</ExpandableFloatingDropdown.Item>
                                ))}
                            </ExpandableFloatingDropdown>
                        </div>
                    </div>

                    <div className="spaced-items-group-xs row row-cards-container row-no-outer-gutter">
                        <div className="spaced-item column-6 column-xs-12">
                            <CustomerGeneralInformation helpInfo={this.props.model.generalInformationHelpInfo.value}/>
                        </div>
                        <div className="spaced-item column-6 column-xs-12">
                            <CustomerAccess helpInfo={this.props.model.accessHelpInfo.value}/>
                            {this.props.model.editInformation &&
                                <CustomerHistory
                                    customerId={CustomerStore.formModel.id.value}
                                    title={this.props.model.title}
                                    helpInfo={this.props.model.historyHelpInfo.value}
                                    editInformation={this.props.model.editInformation}/>}
                        </div>
                    </div>
                </div>
            )
        }
    }
)

window.components.CustomerEditPage = customerEditPage;